/// <reference types="./MutexUtils.d.ts" />
import { notOk } from '@dossierhq/core';
export class Mutex {
    #locking;
    #queueCount;
    constructor() {
        this.#locking = Promise.resolve();
        this.#queueCount = 0;
    }
    #lock() {
        this.#queueCount++;
        let unlockNext;
        const willLock = new Promise((resolve) => (unlockNext = resolve));
        void willLock.then(() => this.#queueCount--);
        const willUnlock = this.#locking.then(() => unlockNext);
        this.#locking = this.#locking.then(() => willLock);
        return willUnlock;
    }
    isLocked() {
        return this.#queueCount > 0;
    }
    async withLock(context, worker) {
        const unlock = await this.#lock();
        try {
            return await worker();
        }
        catch (error) {
            return notOk.GenericUnexpectedException(context, error);
        }
        finally {
            unlock();
        }
    }
}
//# sourceMappingURL=MutexUtils.js.map